import { ColorAdapter } from '@angular-material-components/color-picker';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { RootService } from '@app/core/root.service';
import { ItemProps } from '@app/interfaces';
import { Subject } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-material-color-picker',
  templateUrl: './material-color-picker.component.html',
  styleUrls: ['./material-color-picker.component.scss'],
})
export class MaterialColorPickerComponent implements OnInit, OnDestroy {
  @Input() form: UntypedFormGroup;
  @Input() field: ItemProps;
  @Input() validationErrors: any;
  @Input() service: RootService;
  @Input() cid: string;
  @Input() isEdit: boolean;
  @Input() isClone: boolean;

  @Output() change: EventEmitter<any> = new EventEmitter();
  private destroy$ = new Subject<void>();

  constructor(private colorAdapter: ColorAdapter) {}

  ngOnInit(): void {
    const control = this.form.get(this.field.name);
    if (!control) {
      return;
    }

    const initialNormalized = this.normalizePickerValue(control.value);
    if (initialNormalized && initialNormalized !== control.value) {
      control.setValue(initialNormalized, { emitEvent: false });
    }

    control.valueChanges
      .pipe(startWith(control.value), takeUntil(this.destroy$))
      .subscribe((val: any) => {
        const normalized = this.normalizePickerValue(val);
        if (normalized && normalized !== val) {
          control.setValue(normalized, { emitEvent: false });
          val = normalized;
        }
        this.service.colorPicker = { fieldName: this.field.name, fieldValue: val };
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getColorPreview(value: any): string {
    if (!value) {
      return '#fff';
    }

    if (typeof value === 'string') {
      return value;
    }

    if (typeof value?.rgba === 'string') {
      return value.rgba;
    }

    if (value?.hex) {
      const hex = String(value.hex);
      return hex.startsWith('#') ? hex : `#${hex}`;
    }

    return '#fff';
  }

  private normalizePickerValue(value: any): any {
    if (!value) {
      return value;
    }

    if (typeof value?.toHexString === 'function') {
      return value;
    }

    if (typeof value === 'string') {
      return this.colorAdapter.parse(value) || value;
    }

    if (value?.hex) {
      const hex = String(value.hex);
      return this.colorAdapter.parse(hex.startsWith('#') ? hex : `#${hex}`) || value;
    }

    if (typeof value?.rgba === 'string') {
      return this.colorAdapter.parse(value.rgba) || value;
    }

    return value;
  }
}
